import { Dispatch, useContext, useEffect, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import ImageUploading from 'react-images-uploading';
import AddingAltImages from '../components/add_alt_images';
import styled from 'styled-components';
import imgloading from '../../../../../assets/images/svg/image-loading-icon.svg';
import { ProductListingContext } from '../../../functions/data_formatting_functions';
import { actionSetListingData } from '../../../store/create_listing_actions';
import { Button } from '../../../../../styles/style';
import delete_image from '../../../../../assets/images/svg/delete-icon.svg';
import { MAXIMUM_IMAGE_FOR_LISTING } from '../../../constants';
import ShowImage from '../../../../../components/show_image';
import 'react-image-lightbox/style.css';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import { Colors } from '../../../../../config/theme';
import { ImageType } from '../../../../../data/types/files';
import { StoreDetails } from '../../../../../data/types/stores';
import { S3ApiRepository } from '../../../../../data/repositories/s3_repository';
import { ApiRepository } from '../../../../../data/repositories/base_repository';
import { Checkbox } from '@mui/material';
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  StarOutlined,
  StarFilled,
} from '@ant-design/icons';
import { ListingState } from '../../../../../data/types/listings';
import { FormValidators } from '../../../../../utils/functions/validation_functions';
import { checkDimensions } from '../../../../../pages/image_library/modals/upload_images_modal';
import ImageSelection from '../../../../../components/image_selection';
import { Drawer } from 'antd';
import { PopupWithConfirmation } from '../../../../../components/popups';

type AddPhotosModalProps = {
  isModalVisible: boolean;
  handleCancel: () => void;
  setPhotoBarModal: (value: boolean) => void;
  selection: boolean;
  selectedImage?: ImageType;
  currentStore?: StoreDetails;
  addImagesToAttribute?: (image: ImageType) => void;
  addImagesToVariation?: (image: ImageType) => void;
  s3Repository: S3ApiRepository;
  filesRepository: ApiRepository;
  actionGetStoreImages?: (payload: any) => { type: string; payload: any };
  addOrSelectActionsOnly: boolean;
};

const AddPhotosModal = ({
  currentStore,
  selection,
  addImagesToAttribute,
  addImagesToVariation,
  isModalVisible,
  handleCancel,
  setPhotoBarModal,
  selectedImage,
  s3Repository,
  filesRepository,
  actionGetStoreImages,
  addOrSelectActionsOnly,
}: AddPhotosModalProps) => {
  const {
    state,
    dispatch,
  }: {
    state: ListingState;
    dispatch: Dispatch<any>;
  } = useContext(ProductListingContext);
  const [images, setImages] = useState<any>([]);
  const [selected_image, setSelectedImage] = useState(selectedImage);
  const [imagesToBeUploaded, setImagesToBeUploaded] = useState<any>([]);
  const [uploadedImages, setUploadedImages] = useState<any>([]);
  const [image_url, setImageUrl] = useState('');
  const [wasUploaded, setWasUploaded] = useState(false);
  const [imageIndexToDelete, setImageIndexToDelete] = useState(-1);
  const [page, setPage] = useState(1);
  const [addAltsModal, setAddAltsModal] = useState(false);
  const [image_modal, setImageModal] = useState(false);
  const [delete_modal, setDeleteModal] = useState(false);

  const onChange = async (imageList: any) => {
    const data: any = [];
    let valid = true;
    imageList.map((image: any) => {
      if (image?.file) {
        const ext =
          image?.file?.type.split('/')[image?.file?.type.split('/').length - 1];
        if (ext.trim() === 'svg+xml') {
          valid = false;
        }
      } else {
        return image;
      }
    });
    if (!valid) {
      toast.warning('Only PNG and JPG Images Valid!');
      return;
    }
    imageList.forEach((new_img: any) => {
      let match = false;
      images.forEach((prev_img: any) => {
        if (new_img.file?.name === prev_img.file?.name) {
          match = true;
        }
      });
      if (!match) {
        data.push(new_img);
      }
    });

    setImagesToBeUploaded(data);

    // Uploading Images
    setImages([...imageList]);
  };

  useEffect(() => {
    fetchData();
  }, [imagesToBeUploaded]);

  async function fetchData() {
    if (imagesToBeUploaded.length > 0) {
      setWasUploaded(true);

      if (
        imagesToBeUploaded.length + state?.data?.imagesList?.length >
        MAXIMUM_IMAGE_FOR_LISTING
      ) {
        toast.warning(
          'You can only upload ' + MAXIMUM_IMAGE_FOR_LISTING + ' images',
        );
        setImagesToBeUploaded([]);

        return;
      }
      const successfulImages = await toast.promise(
        s3Repository.addImages({
          images: imagesToBeUploaded,
          is_public: true,
        }),
        {
          pending: 'Uploading images...',
          success: 'Images uploaded successfully!',
          error: 'Error uploading images!',
        },
      );
      successfulImages.map((img: any) => {
        setUploadedImages((uploadedImages: any) => [
          ...uploadedImages,
          img.data.data.file,
        ]);
      });
      setImagesToBeUploaded([]);
    }
  }
  useEffect(() => {
    if (uploadedImages.length > 0) {
      setWasUploaded(true);
      const new_imagesList = uploadedImages.concat(state.data?.imagesList);
      dispatch(
        actionSetListingData({
          ...state.data,
          images: new_imagesList.map((img: any) => img?.id),
          imagesList: new_imagesList,
          notToUploadImages: [],
        }),
      );
      setUploadedImages([]);
    }
  }, [uploadedImages]);

  const checkSelection = (index: number) => {
    if (state.data?.imagesList[index] && selection) {
      if (state.data?.imagesList[index]?.id === selected_image?.id) {
        return 'selected_image';
      } else {
        return '';
      }
    } else {
      return '';
    }
  };

  const nextCall = () => {
    if (state.data?.imagesList.length === 0) {
      toast.warning('You must have at least one image for your listing');
      return;
    }
    if (selection) {
      if (selected_image?.id) {
        if (addImagesToAttribute) addImagesToAttribute(selected_image);
        if (addImagesToVariation) {
          if (state.data?.notToUploadImages.includes(selected_image.id)) {
            toast.warning(
              'This image is set to be hidden, please unhide it first or select another image',
            );
            return;
          }
          addImagesToVariation(selected_image);
        }
        setSelectedImage(undefined);
        setImagesToBeUploaded([]);
      } else {
        toast.warning('Please Select Image First!');
      }
    } else {
      setPage(page + 1);
      setAddAltsModal(true); //todo
    }
  };

  const addImageFromUrl = async () => {
    if (!FormValidators.isURL(image_url)) {
      toast.warning('Please enter a valid image url!');
      return;
    }
    const image: {
      error: boolean;
      file?: File | undefined;
    } = await s3Repository.blobUrlToFile(image_url).then((res: any) => {
      () => setImageUrl('');
      return res;
    });
    if (!image.error) {
      setWasUploaded(true);
      setImagesToBeUploaded([...imagesToBeUploaded, { file: image.file }]);
      setImages([...images, { file: image.file }]);
      setImageUrl('');
    } else {
      toast.warn('Something went wrong! maybe url is not correct!');
    }
  };

  const closeModal = () => {
    if (!wasUploaded) {
      handleCancel();
      setWasUploaded(false);
    }
  };

  const removeImage = async (index: number) => {
    const new_imagesList = state.data?.imagesList.filter(
      (_: ImageType, ind: number) => index !== ind,
    );
    dispatch(
      actionSetListingData({
        ...state.data,
        images: new_imagesList.map((img: ImageType) => img.id),
        imagesList: new_imagesList,
      }),
    );
    closeDeleteModal();
    // await deleteImage(image.id);
  };
  const closeDeleteModal = () => {
    setDeleteModal(false);
    setImageIndexToDelete(-1);
  };

  const openDeleteModal = (index: number) => {
    setDeleteModal(true);
    setImageIndexToDelete(index);
  };

  const handlePhotoBar = () => {
    if (!wasUploaded) {
      setAddAltsModal(false);
      setWasUploaded(false);
      setPage(1);
    }
  };

  return (
    <>
      <ImageSelection
        showModal={image_modal}
        minNumberOfImages={1}
        maxNumberOfImages={MAXIMUM_IMAGE_FOR_LISTING}
        updateSelectedImages={(images) => setUploadedImages(images)}
        setImageModal={setImageModal}
        store_id={currentStore?.id.toString()}
        actionGetStoreImages={actionGetStoreImages}
        s3Repository={s3Repository}
        filesRepository={filesRepository}
      />

      <Drawer
        open={isModalVisible && !image_modal}
        width={'60%'}
        zIndex={50}
        onClose={
          () => handleCancel()
          // image_modal
          //   ? setImageModal(false)
          //   : addAltsModal
          //     ? handlePhotoBar()
          //     : closeModal()
        }
        title={
          <>
            <h4>Add photos to the item</h4>
            <p
              style={{
                color: Colors.greyStrong,
                fontSize: '14px',
                padding: '0px 10px',
                marginBottom: '0px',
              }}
            >
              <span
                style={{
                  color: Colors.greenMain,
                  fontSize: '14px',
                  fontWeight: 600,
                }}
              >
                Hint:{' '}
              </span>
              To select an image as the main product image, click on the{' '}
              <StarOutlined
                style={{
                  color: Colors.greenMain,
                  fontSize: '14px',
                }}
              />{' '}
              icon. <br />
              <span
                style={{
                  color: Colors.greenMain,
                  fontSize: '14px',
                  fontWeight: 600,
                }}
              >
                Hint:{' '}
              </span>
              To hide image from product images (but keep it for attributes)
              click on the eye{' '}
              <EyeOutlined
                style={{
                  color: Colors.greenMain,
                  fontSize: '14px',
                  fontWeight: 600,
                }}
              />{' '}
              icon. <br />
              <span
                style={{
                  color: Colors.greenMain,
                  fontSize: '14px',
                  fontWeight: 600,
                }}
              >
                Hint:{' '}
              </span>
              Double click on an image to select it.
              {addOrSelectActionsOnly && (
                <>
                  <br />
                  <span
                    style={{
                      color: Colors.tomatoRed,
                      fontSize: '12px',
                      fontWeight: 600,
                    }}
                  >
                    {' '}
                    Images here are select or add only! to delete, hide or
                    un-hide images, please go back to Specifications or Media
                    step.
                  </span>
                </>
              )}
            </p>
          </>
        }
        placement="right"
        extra={
          <Button
            color={'white'}
            onClick={() => nextCall()}
            style={{
              marginBottom: '10px',
              width: '20%',
              backgroundColor:
                state.data?.imagesList?.length < 1
                  ? Colors.grey
                  : Colors.greenMain,
            }}
          >
            Save
          </Button>
        }
      >
        <PopupWithConfirmation
          headerTitle="Delete Image from Listing"
          bodyText="Are you sure you want to delete selected image?"
          buttonTwoText="Delete"
          buttonOneText="Cancel"
          onButtonTwoClick={() => removeImage(imageIndexToDelete)}
          onButtonOneClick={() => closeDeleteModal()}
          open={delete_modal}
          withTimerOfNSeconds={null}
        />

        <Wrapper>
          <Offcanvas.Body>
            {/* <button onClick={changeContent}> click here</button> */}
            <ImageUploading
              multiple
              value={images}
              onChange={async (value) => {
                if (
                  value &&
                  value.length > 0 &&
                  (await checkDimensions(value[value.length - 1]?.file!))
                ) {
                  onChange(value);
                }
              }}
              maxNumber={MAXIMUM_IMAGE_FOR_LISTING}
              dataURLKey="data_url"
              allowNonImageType={false}
            >
              {({ onImageUpload, isDragging, dragProps }) => (
                <div className="contain">
                  <div className="grid-container">
                    {Array.from(
                      { length: MAXIMUM_IMAGE_FOR_LISTING },
                      (_, i) => ({
                        id: i,
                      }),
                    ).map((_, index) => {
                      return (
                        <div
                          key={index}
                          className={`${checkSelection(index)}`}
                          onClick={() =>
                            state.data?.imagesList[index]
                              ? setSelectedImage(state.data?.imagesList[index])
                              : {}
                          }
                          onDoubleClick={() => {
                            state.data?.imagesList[index]
                              ? setSelectedImage(state.data?.imagesList[index])
                              : {};
                            nextCall();
                          }}
                        >
                          {state.data?.imagesList[index] ? (
                            <div
                              className="media_image"
                              onClick={() =>
                                setSelectedImage(state.data?.imagesList[index])
                              }
                            >
                              {!addOrSelectActionsOnly && (
                                <>
                                  <div // <Icon
                                    className="delete-button"
                                    style={{
                                      position: 'absolute',
                                      top: 0,
                                      right: 0,
                                      transform: 'translate(0%, -50%)',
                                    }}
                                    onClick={() => {
                                      if (
                                        state.data?.notToUploadImages.includes(
                                          state.data?.imagesList[index].id,
                                        )
                                      ) {
                                        toast.warning(
                                          'You cannot delete an image that is set to be hidden',
                                        );
                                        return;
                                      }
                                      if (
                                        state.data?.imagesList.length !== 1 &&
                                        state.data?.imagesList.length ===
                                          state.data.notToUploadImages.length +
                                            1
                                      ) {
                                        toast.warning(
                                          'You must have at least one image for your listing',
                                        );
                                        return;
                                      }
                                      openDeleteModal(index);
                                    }}
                                  >
                                    <img
                                      className="del-button"
                                      src={delete_image}
                                      alt="remove_image"
                                    />
                                  </div>

                                  <div // <Icon
                                    style={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      transform: 'translate(0%, 0%)',
                                    }}
                                  >
                                    <Checkbox
                                      icon={
                                        <EyeInvisibleOutlined
                                          style={{
                                            color: Colors.tomatoRed,
                                            fontSize: '20px',
                                          }}
                                        />
                                      }
                                      checkedIcon={
                                        <EyeOutlined
                                          style={{
                                            color: Colors.greenMain,
                                            fontSize: '20px',
                                          }}
                                        />
                                      }
                                      checked={
                                        state.data?.notToUploadImages?.includes(
                                          state.data?.imagesList[index].id,
                                        )
                                          ? false
                                          : true
                                      }
                                      onChange={(e) => {
                                        if (addOrSelectActionsOnly) return;
                                        if (e.target.checked) {
                                          const newImages =
                                            state.data?.notToUploadImages
                                              .filter(
                                                (img) =>
                                                  img !==
                                                  state.data?.imagesList[index]
                                                    .id,
                                              )
                                              .map((img) => img);
                                          toast.info(
                                            'This image will be shown in the product page',
                                          );
                                          dispatch(
                                            actionSetListingData({
                                              ...state.data,
                                              notToUploadImages: [...newImages],
                                            }),
                                          );
                                        } else {
                                          if (
                                            state.data?.imagesList.length ===
                                            state.data.notToUploadImages
                                              .length +
                                              1
                                          ) {
                                            toast.warning(
                                              'You must have at least one image for your listing',
                                            );
                                            return;
                                          }

                                          let newImages: number[] = [];
                                          if (state.data?.notToUploadImages) {
                                            newImages = [
                                              ...state.data.notToUploadImages,
                                              state.data?.imagesList[index].id,
                                            ];
                                          } else {
                                            newImages = [
                                              state.data?.imagesList[index].id,
                                            ];
                                          }
                                          toast.info(
                                            'This image will not be shown in the product page, but you can use it for attributes.',
                                          );
                                          dispatch(
                                            actionSetListingData({
                                              ...state.data,
                                              notToUploadImages: newImages,
                                            }),
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                  <div // <Icon
                                    style={{
                                      position: 'absolute',
                                      bottom: 0,
                                      left: 0,
                                      transform: 'translate(0%, 0%)',
                                    }}
                                  >
                                    <Checkbox
                                      title="Set as cover image"
                                      icon={
                                        <StarOutlined
                                          style={{
                                            color: Colors.greenMain,
                                            fontSize: '20px',
                                          }}
                                        />
                                      }
                                      checkedIcon={
                                        <StarFilled
                                          style={{
                                            color: Colors.greenMain,
                                            fontSize: '20px',
                                          }}
                                        />
                                      }
                                      checked={
                                        state.data?.cover_image_id ===
                                        state.data?.imagesList[index].id
                                          ? true
                                          : false
                                      }
                                      onChange={() => {
                                        if (addOrSelectActionsOnly) return;
                                        dispatch(
                                          actionSetListingData({
                                            ...state.data,
                                            cover_image_id:
                                              state.data?.imagesList[index].id,
                                          }),
                                        );
                                      }}
                                    />
                                  </div>
                                </>
                              )}

                              <ShowImage
                                image={state.data?.imagesList[index]}
                                style={{
                                  objectFit: 'scale-down',
                                  width: '100px',
                                  height: '100px',
                                }}
                              />
                              {addOrSelectActionsOnly && (
                                <p
                                  style={{
                                    margin: 0,
                                    position: 'absolute',
                                    bottom: 0,
                                    transform: 'translate(0%, 5%)',
                                    color: Colors.alternateText,
                                  }}
                                >
                                  {state.data?.imagesList[index]?.alt}
                                </p>
                              )}
                            </div>
                          ) : (
                            <div className="media_image" />
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <div className="text-center wrap d-flex justify-content-between">
                    <div className="line" />
                    <div className="text">OR</div>
                    <div className="line" />
                  </div>
                  <div
                    className={`section text-center ${isDragging && 'active'} mt-4`}
                    style={
                      isDragging
                        ? {
                            color: Colors.greenMain,
                            border: `2px solid ${Colors.greenMain}`,
                          }
                        : { cursor: 'pointer' }
                    }
                    onClick={onImageUpload}
                    {...dragProps}
                  >
                    <img
                      src={imgloading}
                      alt="..."
                      style={{
                        margin: 'auto',
                        paddingBottom: '10px',
                      }}
                    />
                    <h6>Click or Drag and drop images to upload files</h6>
                    <p>Supported formats: PNG, JPG, JPEG, SVG, WEBP, BMP</p>
                  </div>

                  <div className="text-center wrap d-flex justify-content-between">
                    <div className="line" />
                    <div className="text">OR</div>
                    <div className="line" />
                  </div>

                  <button
                    className="butn"
                    onClick={() => {
                      setImageModal(!image_modal);
                    }}
                  >
                    Choose From Library
                  </button>
                  <div className="text-center wrap d-flex justify-content-between">
                    <div className="line mr-2" />
                    <div className="text"> OR </div>
                    <div className="line ml-2" />
                  </div>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Image URL"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                      value={image_url}
                      onChange={(e) => setImageUrl(e.target.value)}
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      id="basic-addon2"
                      style={{
                        backgroundColor:
                          image_url === '' ? 'gray' : Colors.greenMain,
                        cursor: image_url === '' ? 'not-allowed' : 'pointer',
                      }}
                      onClick={image_url === '' ? () => {} : addImageFromUrl}
                    >
                      Add
                    </span>
                  </div>
                </div>
              )}
            </ImageUploading>
          </Offcanvas.Body>
        </Wrapper>

        {addAltsModal && (
          <AddingAltImages
            setPhotoBarModal={setPhotoBarModal}
            setAddAltsModal={setAddAltsModal}
            setWasUploaded={setWasUploaded}
            currentStore={currentStore}
            filesRepository={filesRepository}
          />
        )}
      </Drawer>
    </>
  );
};

export const Wrapper = styled.div`
  overflow: auto;
  .itsoffCanvas {
    overflow: auto;
    z-index: 500;
  }

  .back-arrow-btn {
    background-color: transparent;
    border: none;
    outline: none;
  }
  .grid-container {
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    gap: 10px;
    padding: 10px 0px 15px 0px;
  }

  .grid-container > div {
    background-color: #f4f7f8;
    border-radius: 5px;
    text-align: center;
    font-size: 12px;
    width: 100%;
    height: 100%;
    min-height: 100px;
    max-height: 105px;
    max-width: 105px;
    min-width: 100px;
  }

  .media_image {
    margin-top: auto;
    margin-bottom: auto;
    position: relative;
  }
  .cover {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 3;
    height: 100%;
    padding: 50px 0% 0px 0px;
  }
  .selected_image {
    border: 2px solid var(--app-color-dark);
    border-radius: 16px;
  }

  .active {
    border: 1px solid #05ae4b;
    border-radius: 5px;

    .cross {
      margin-top: -133px;
      margin-right: -139px;
    }
  }
  .del-button {
    background: var(--color-del);
    border-radius: 3px;
    margin-left: 15px;
    margin-top: 25px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .section {
    padding: 10px 0px;
    width: 100%;
    background: #f4f7f8;
    border: 2px dashed #82d6a5;
    border-radius: 4px;
    h6 {
      cursor: pointer;
    }
  }
  .section.active {
    border: 2px dashed var(--app-color-dark);
  }
  .input-group {
    padding-top: 20px;
    span {
      background: #05ae4b;
      color: white;
      border-radius: 5px;
    }
  }
  .wrap {
    color: #abb7bd;
    .line {
      width: 46%;
      border-bottom: 1px solid #e8e8e8;
      margin-bottom: 9px;
    }
    .text {
      padding-top: 7px;
    }
  }
  .butn {
    color: #05ae4b;
    background: #cdefdb;
    border-radius: 5px;
    width: 100%;
    border: none;
    padding: 14px;
    margin-top: 10px;
  }
  .butn1 {
    display: flex;
    justify-content: flex-end;
    top: 10%;
    right: 1%;
    padding-top: 10px;
  }

  .image-box {
    margin: 20px;
    max-width: 80%;
    max-height: 400px;
  }
  .alt-images {
    // height: 120px;
    margin: 5px;
    background-color: var(--white-color);
    border: none;
  }
  .alt-images.active {
    border: 3px solid #05ae4b;
    border-radius: 12px;
  }
  .buttons-group {
    gap: 15px;
    .select-btn {
      border: none;
      outline: none;
      border-radius: 8px;
      background-color: transparent;
      width: 120px;
      height: 120px;
    }
    .active {
      border: 3px solid #05ae4b;
      border-radius: 12px;
    }
  }
`;

export default AddPhotosModal;
